import {
  IBienLaiThu,
  IBienLaiThuViewModel,
} from "../../../model/respone/bien-lai/IBienLaiThu";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { ILuyKeSinhVienRespone } from "../../../model/respone/report/ITongHopSinhVienRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface ITongHopSinhVienDataType<T> {
  data: T;
  id_sv: string;
}

export const eTongHopSinhVienActionsObj = {
  LOAD_LUY_KE_SO_LIEU_START: "",
  LOAD_LUY_KE_SO_LIEU_SUCCESS: {} as ILuyKeSinhVienRespone,
  LOAD_LUY_KE_SO_LIEU_ERROR: {} as string,

  LOAD_LUY_KE_MUC_THU_START: "",
  LOAD_LUY_KE_MUC_THU_SUCCESS: {} as ITongHopSinhVienDataType<
    IMucThuKhacSinhVienViewModel[]
  >,
  LOAD_LUY_KE_MUC_THU_ERROR: {} as string,

  LOAD_LUY_KE_BIEN_LAI_START: "",
  LOAD_LUY_KE_BIEN_LAI_SUCCESS: {} as ITongHopSinhVienDataType<
    IBienLaiThuViewModel[]
  >,
  LOAD_LUY_KE_BIEN_LAI_ERROR: {} as string,
};
export const eTongHopSinhVienActionIds = generateActionTypeIds(
  eTongHopSinhVienActionsObj,
  "TONG_HOP_SINH_VIEN"
);
export type ITongHopSinhVienActionTypes = IGenericActionType<
  typeof eTongHopSinhVienActionsObj,
  "TONG_HOP_SINH_VIEN"
>;
